import React from 'react';
import participants from '../../assets/img/participants-img.svg';
import { t } from '../../../../../../../utils/helpers';

export const ParticipantsEmpty = () => {
  return (
    <div className="list-participants">
      <div className="list-participants__empty-card">
        <img
          className="list-participants__img"
          src={participants}
          alt="avatar"
        />
        <h2 className="list-participants__title">{`${t(
          'wait_for_the_participants'
        )}...`}</h2>
      </div>
    </div>
  );
};
